// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import TerceraBrokerInfoScreenTemplate from '@front/templates/TerceraBrokerInfoScreenTemplate.html';
import { TerceraWindowBase } from './TerceraWindowBase';
import { DataCache } from '@shared/commons/DataCache';
export class TerceraBrokerInfoScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    getType() {
        return 'TerceraBrokerInfoScreen';
    }
    oncomplete() {
        super.oncomplete();
        this.fillWithBrokerInfo();
        this.updateBrandingImage();
        this.localize();
    }
    dispose() {
        var _a;
        (_a = this.scroll) === null || _a === void 0 ? void 0 : _a.destroy();
        super.dispose();
    }
    fillWithBrokerInfo() {
        const info = DataCache.BrokerInformation;
        const container = this.find('.js-broker-info-text');
        if (isNullOrUndefined(info) || isNullOrUndefined(container)) {
            return;
        }
        const infoArr = info.split(';');
        for (let i = 0; i < infoArr.length; i++) {
            const d = document.createElement('div');
            d.style = 'margin-top: 24px;';
            d.innerText += infoArr[i] + '\n';
            container.appendChild(d);
        }
        this.scroll = HtmlScroll.addScroll(container, 'xy');
    }
    localize() {
        void this.set({ header: Resources.getResource('screen.brokerInfo.header') });
    }
}
TerceraWindowBase.extendWith(TerceraBrokerInfoScreen, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            movable: false,
            showHeader: true,
            showFooter: false,
            resizable: false,
            canSelect: false,
            alwaysMiddle: true,
            showFullscreenCloud: true,
            focused: true,
            width: 400,
            height: 400
        };
    },
    partials: { bodyPartial: TerceraBrokerInfoScreenTemplate }
});
